import { PublicKey } from '../auth.interface';
import bs58 from 'bs58';
export class Ed25519PublicKey extends PublicKey {
    constructor(value) {
        super();
        if (typeof value === 'string' && value.startsWith('0x')) {
            // oof
            const enc = new TextEncoder();
            this.value = enc.encode(value);
        }
        else if (typeof value === 'string') {
            this.value = bs58.decode(value);
        }
        else {
            this.value = value;
        }
    }
    toBytes() {
        return this.value;
    }
    toString() {
        return bs58.encode(this.value);
    }
}
//# sourceMappingURL=ed25519-public-key.js.map